var getToLocaleStringSupportsLocales = function () {
    try {
        var num = 0;
        num.toLocaleString('i');
    }
    catch (e) {
        return e.name === 'RangeError';
    }
    return false;
};
export var toLocaleStringSupportsLocales = getToLocaleStringSupportsLocales();
//# sourceMappingURL=toLocaleStringSupportsLocales.js.map